import React, { useEffect, useMemo, useState } from "react";
import { Col, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";

// Components
import Header, { HeaderNav, Menu } from "./Header";

// Data
import RDPHeaderData from "./RDPHeaderData";

// Hooks
import { useCategoriesWithProducts } from "../../hooks/useCategoriesWithProducts";

// Logo RDP
import LogoRDP from "../../Assets/img/products/Logo RDP sans fond - copie.png";
import { supabase } from "../../lib/supabaseClient";
import { useCart } from "../../contexts/CartContext";

const RDPHeader = (props) => {
  const [isAdmin, setIsAdmin] = useState(false)
  const [session, setSession] = useState(null)
  const { cartCount } = useCart()
  const { categories: categoriesWithProducts } = useCategoriesWithProducts()

  const allowedAdmins = useMemo(() => {
    const raw = process.env.REACT_APP_ADMIN_EMAILS || ''
    return raw
      .split(',')
      .map(s => s.trim().toLowerCase())
      .filter(Boolean)
  }, [])

  // Filtrer le menu pour ne montrer que les catégories ayant des produits
  const filteredHeaderData = useMemo(() => {
    return RDPHeaderData.map(item => {
      // Si c'est le menu "Produits" avec dropdown
      if (item.title === 'Produits' && item.dropdown) {
        const filteredDropdown = item.dropdown.filter(dropdownItem => {
          // Toujours garder "Tout"
          if (dropdownItem.link === '/produits/tout') return true
          // Extraire le slug de la catégorie depuis le lien (ex: /produits/vin -> vin)
          const slug = dropdownItem.link.replace('/produits/', '')
          return categoriesWithProducts.includes(slug)
        })
        return { ...item, dropdown: filteredDropdown }
      }
      return item
    })
  }, [categoriesWithProducts])

  useEffect(() => {
    let mounted = true
    const init = async () => {
      const { data } = await supabase.auth.getSession()
      if (!mounted) return
      setSession(data.session)

      const email = data.session?.user?.email?.toLowerCase()
      let ok = false
      if (email && allowedAdmins.length > 0 && allowedAdmins.includes(email)) ok = true
      // Essayez de lire le profil pour rôle admin si la table existe
      try {
        if (!ok && data.session?.user) {
          const { data: prof } = await supabase.from('profiles').select('role').eq('id', data.session.user.id).single()
          if (prof?.role === 'admin') ok = true
        }
      } catch (_) {}
      setIsAdmin(!!ok)
    }
    init()
    const { data: listener } = supabase.auth.onAuthStateChange((_e, s) => {
      setSession(s)
      const email = s?.user?.email?.toLowerCase()
      const ok = email && allowedAdmins.length > 0 && allowedAdmins.includes(email)
      setIsAdmin(!!ok)
    })
    return () => { mounted = false; listener?.subscription?.unsubscribe?.() }
  }, [allowedAdmins])
  return (
    <Header topSpace={{ md: true }} type="always-fixed" className="glass-header">
      <HeaderNav
        fluid="fluid"
        theme="light"
        bg="transparent"
        menu="light"
        expand="lg"
        className="py-[0px] px-[35px] md:px-[15px] md:py-[20px] sm:px-0"
      >
        {/* Logo à gauche */}
        <Col lg={2} sm={6} xs={"auto"} className="mr-auto ps-0">
          <Link aria-label="header logo" className="flex items-center" to="/">
            <Navbar.Brand className="inline-block p-0 m-0">
              <img
                className="default-logo"
                width="111"
                height="36"
                loading="lazy"
                src={LogoRDP}
                alt='RDP Glass Logo'
              />
              <img
                className="alt-logo"
                width="111"
                height="36"
                loading="lazy"
                src={LogoRDP}
                alt='RDP Glass Logo'
              />
              <img
                className="mobile-logo"
                width="111"
                height="36"
                loading="lazy"
                src={LogoRDP}
                alt='RDP Glass Logo'
              />
            </Navbar.Brand>
          </Link>
        </Col>

        {/* Menu toggle et menu mobile */}
        <Navbar.Toggle className="order-last md:ml-[17px]">
          <span className="navbar-toggler-line"></span>
          <span className="navbar-toggler-line"></span>
          <span className="navbar-toggler-line"></span>
          <span className="navbar-toggler-line"></span>
        </Navbar.Toggle>

        {/* Menu principal centré */}
        <Navbar.Collapse className="justify-center col-auto col-lg-8">
          <Menu data={filteredHeaderData} {...props} />
        </Navbar.Collapse>

        {/* Actions à droite */}
        <Col lg={2} xs={"auto"} className="justify-end pe-0 flex items-center gap-3">
          {/* Panier de contact */}
          <Link
            to="/contact"
            className="relative inline-flex items-center justify-center"
            title="Ma demande de contact"
          >
            <i className="line-icon-Add-Basket text-[22px] text-glass-darkest hover:text-glass-accent transition-colors"></i>
            {cartCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-glass-accent text-white text-[10px] font-bold rounded-full w-[18px] h-[18px] flex items-center justify-center">
                {cartCount}
              </span>
            )}
          </Link>

          {isAdmin && (
            <Link to="/admin" className="px-3 py-1 rounded-full border border-[#3B82F6] text-[#3B82F6] hover:bg-[#3B82F6] hover:text-white transition-colors text-sm">
              Dashboard
            </Link>
          )}
        </Col>
      </HeaderNav>
    </Header>
  );
};

export default RDPHeader;
